import { id, root } from './hardware-models';

export const hardwareModels = {
  ...root,
  id,
};
